/**
 * Plugin to initialize user data on app startup.
 * This ensures user data is fetched before any route navigation.
 */
export default defineNuxtPlugin(async () => {
  const userStore = useUserStore();

  // Fetch user data on app initialization
  if (!userStore.isInitialized) {
    await userStore.fetchUser();
  }
});
